import './scss/style.scss';
import domReady from '@wordpress/dom-ready';
import AddNewQuote from './pages/AddNewQuote';
import RequestQuoteList from './pages/RequestQuoteList';
import QuoteRulesList from './pages/QuoteRulesList';
import AddNewQuoteRule from './pages/AddNewQuoteRule';

domReady( () => {
    // @ts-ignore
    wp.hooks.addFilter(
        'dokan-admin-dashboard-routes',
        'dokan-admin-request-quote-panel',
        ( routes ) => {
            routes.push( {
                id: 'request-quote',
                element: <RequestQuoteList />,
                path: '/request-for-quote',
            } );

            routes.push( {
                id: 'request-quote-rules-list',
                element: <QuoteRulesList />,
                path: '/request-for-quote/quote-rules',
            } );

            routes.push( {
                id: 'request-new-quote',
                element: <AddNewQuote />,
                path: '/request-for-quote/add-new-quote',
            } );

            routes.push( {
                id: 'request-edit-quote',
                element: <AddNewQuote />,
                path: '/request-for-quote/edit-quote/:id',
            } );

            routes.push( {
                id: 'add-new-quote-rule',
                element: <AddNewQuoteRule />,
                path: '/request-for-quote/add-new-rule',
            } );

            routes.push( {
                id: 'edit-quote-rule',
                element: <AddNewQuoteRule />,
                path: '/request-for-quote/edit-quote-rule/:id',
            } );

            return routes;
        }
    );
} );
